import {styled, useTheme} from "@mui/material";
import React, {useEffect, useState} from "react";
import {Outlet} from "react-router-dom";
import FooterBeforeLogin from "../navbar/FooterBeforeLogin";
import NavBarBeforeLogin from "../navbar/NavBarBeforeLogin";
import {dashboardinstructionAPi} from "../../http/allApis";

const OutletDiv = styled("div")(({ theme }) => ({
  minHeight: "100vh",
  overflow: "auto",
  width: "100%",
  cursor: "default",
  [theme.breakpoints.down(1200)]: {
    height: "auto",
  },
}));

function LandingPage() {
  const theme = useTheme();
  const [anncBannerData, setAnncBannerData] = useState([]);
  const [enableAnnouncmentBanner, setEnableAnnouncmentBanner] = useState(false);

  useEffect(() => {
    let isMounted = true; // Track if component is still mounted

    window.scroll(0, 0);

    const getBannerAnnouncement = async () => {
      try {
        const res = await dashboardinstructionAPi();
        if (!isMounted) return; // Prevent updating state if unmounted

        if (res?.data?.status === "Success") {
          const anncBData = res?.data?.data;
          const annoucmentStatusValue = anncBData.filter(
              (item) => item.announcementStatus
          );
          const enableAnnouncement =
              annoucmentStatusValue && annoucmentStatusValue?.length > 0;
          const getFirstPositionAnnouncement =
              annoucmentStatusValue?.length > 0 ? annoucmentStatusValue?.[0] : {};

          setAnncBannerData(getFirstPositionAnnouncement);
          setEnableAnnouncmentBanner(enableAnnouncement);
        }
      } catch (error) {
        console.error("Error fetching banner announcement:", error);
      }
    };

    getBannerAnnouncement();

    return () => {
      isMounted = false; // Cleanup function
    };
  }, []);


  return (
    <div>
      {enableAnnouncmentBanner ? (
        <div
          style={{
            ...(anncBannerData.backgroundType === false
              ? {
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundImage:
                    "url(" + anncBannerData.backgroundImage + ")",
                }
              : {
                  backgroundColor:
                    theme.palette.mode === "dark"
                      ? theme.palette.background.default
                      : anncBannerData.backgroundColor,
                }),
            display: "flex",
            height: "40%",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "0.875rem",
            lineHeight: "1.25rem",
            padding: "1rem 0.75rem 1rem 1rem",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "baseline",
            }}
          >
            <div>
              <p
                style={{
                  textAlign: "center",
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.background.default
                      : anncBannerData.textColor,
                }}
                dangerouslySetInnerHTML={{
                  __html: anncBannerData.description,
                }}
              ></p>
            </div>
          </div>
        </div>
      ) : null}
      <NavBarBeforeLogin />
      <OutletDiv>
        <Outlet />
      </OutletDiv>
      <FooterBeforeLogin />
    </div>
  );
}

export default LandingPage;
